import axios from "axios";
import { requestError } from "../utils/RequestError";

export const getListContactUs = async (params) => {
  try {
    const res = await axios.get(`/admin/contact-us`, { params });
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const getContactUsById = async (id) => {
  try {
    const res = await axios.get(`/admin/contact-us/${id}`);
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const deleteContactUs = async (id) => {
  try {
    const res = await axios.delete(`/admin/contact-us/${id}`);
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};
